import React from "react";
import { Constants } from "../../CommonMethhods/Constants";

function DpReportTable(props) {
  const { gridVal, selection, flag } = props;

  return (
    <>
      <div className="table-responsive scroll-table report-table-wrapper">
        <table className="table last-column">
          <thead>
            {selection === "bill-tran" ? (
              flag === "tran" ? (
                <tr>
                  <th scope="col">Txn.Date</th>
                  <th scope="col" className="text-center">
                    {Constants.Isin}
                  </th>
                  <th scope="col" className="text-center">
                    {Constants.Instrument}
                  </th>
                  <th scope="col" className="text-center">
                    {Constants.Charges_Details}
                  </th>
                  <th scope="col" className="text-center">
                    {Constants.Quantity}
                  </th>
                  <th scope="col" className="text-center">
                    {Constants.Holdings}
                  </th>
                </tr>
              ) : (
                <>
                  <tr>
                    <th scope="col">{Constants.Txn_Date}</th>
                    <th scope="col" className="text-center">
                      {Constants.Trans_No}
                    </th>
                    <th scope="col" className="text-center">
                      {Constants.Isin}
                    </th>
                    <th scope="col" className="text-center">
                      {Constants.Instrument}
                    </th>
                    <th scope="col" className="text-center">
                      {Constants.Charges_Details}
                    </th>
                    <th scope="col" className="text-center">
                      {Constants.Opening_Qty}
                    </th>
                    <th scope="col" className="text-center">
                      {Constants.Credit_Qty}
                    </th>
                    <th scope="col" className="text-center">
                      {Constants.Debit_Qty}
                    </th>
                    <th scope="col" className="text-center">
                      {Constants.Balance_Qty}
                    </th>
                    <th scope="col" className="text-center">
                      {Constants.Charges}
                    </th>
                    <th scope="col" className="text-center">
                      {Constants.Taxes}
                    </th>
                    <th scope="col" className="text-center">
                      {Constants.Total_Charges}
                    </th>
                    <th scope="col" className="text-center">
                      {Constants.Holdings}
                    </th>
                  </tr>
                </>
              )
            ) : (
              <tr>
                <th scope="col">{Constants.Txn_Date}</th>
                <th scope="col" className="text-center">
                  Scrip Name
                </th>
                <th scope="col" className="text-center">
                  {Constants.Quantity}
                </th>
                <th scope="col" className="text-center">
                  Remarks
                </th>
              </tr>
            )}
          </thead>

          <tbody>
            {selection === "bill-tran"
              ? flag === "tran"
                ? gridVal?.map((item, key) => {
                    return (
                      <tr key={key}>
                        <td>{item?.txnDate || "-"}</td>
                        <td>{item?.isin || "-"}</td>
                        <td>{item?.instrument || "-"}</td>
                        <td>{item?.chargesDetails || "-"}</td>
                        <td>{item?.quantity || 0}</td>
                        <td>{item?.holding || 0}</td>
                      </tr>
                    );
                  })
                : gridVal?.map((item, key) => {
                    return (
                      <tr key={key}>
                        <td>{item?.txnDate || "-"}</td>
                        <td>{item?.transNo || "-"}</td>
                        <td>{item?.isin || "-"}</td>
                        <td>{item?.instrument || "-"}</td>
                        <td>{item?.chargesDetails || "-"}</td>
                        <td>{item?.openingQty || 0}</td>
                        <td>{item?.creditQty || 0}</td>
                        <td>{item?.debitQty || 0}</td>
                        <td>{item?.balanceQty || 0}</td>
                        <td>{item?.charges || 0}</td>
                        <td>{item?.taxes || 0}</td>
                        <td>{item?.totalCharges || 0}</td>
                        <td>{item?.holding || 0}</td>
                      </tr>
                    );
                  })
              : gridVal.map((item, key) => {
                  return (
                    <tr key={key}>
                      <td>{item?.txnDate || "-"}</td>
                      <td>{item?.scripName || "-"}</td>
                      <td>{item?.qty || 0}</td>
                      <td>{item?.remarks || "-"}</td>
                    </tr>
                  );
                })}
          </tbody>
        </table>
      </div>
    </>
  );
}
export default DpReportTable;
